/**
 * Mobile: when the country selector opens inside a scrollable container (e.g. menu drawer),
 * scroll so the full accordion is visible and not cropped at the bottom.
 */
document.addEventListener(
  'toggle',
  (event) => {
    const target = event.target;
    if (!(target instanceof HTMLDetailsElement)) return;
    if (!target.classList.contains('country-selector-accordion')) return;
    if (!target.open) return;
    if (!window.matchMedia('(max-width: 749px)').matches) return;

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        target.scrollIntoView({
          block: 'end',
          behavior: 'smooth',
          inline: 'nearest',
        });
      });
    });
  },
  true,
);
